import axios from 'axios';
import store from './store/store';

async function post(url, data) {
  //console.log('LA DATA:::', data)
  let token =
    (await sessionStorage.getItem('token')) || store.state.token;
  //console.log('EL TOKEN:::', token)
  return new Promise((resolve, reject) => {
    axios
      .post(`${store.state.baseURL}${url}`, data, {
        timeout: 20000,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}

async function get(url) {
  let token =
    (await sessionStorage.getItem('token')) || store.state.token;
  // console.log('EL TOKEN:::', token)
  return new Promise((resolve, reject) => {
    axios
      .get(`${store.state.baseURL}${url}`, {
        timeout: 20000,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default {
  post,
  get,
};
